import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberSubmission } from '../../../../models/submissions/member-submission';

@Component({
  selector: 'app-investment-instruction-submission-changes-card',
  templateUrl: './investment-instruction-submission-changes-card.component.html',
  styleUrls: ['./investment-instruction-submission-changes-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestmentInstructionSubmissionChangesCardComponent {
  @Input() submission!: MemberSubmission;
}
